// extracted by mini-css-extract-plugin
module.exports = {"contactList":"ContactList_contactList__3izgR"};